"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { CheckIcon, CopyIcon as CopyIconSVG } from "@radix-ui/react-icons";
import { useClipboard } from "../hooks/useCopyClipboard.js";
import { ToolTip } from "./Tooltip.js";
import { Container } from "./basic.js";
/**
 * @internal
 */
export const CopyIcon = (props) => {
    const { hasCopied, onCopy } = useClipboard(props.text);
    const showCheckIcon = props.hasCopied || hasCopied;
    return (_jsx("div", { onClick: onCopy, style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }, onKeyDown: (e) => {
            if (e.key === "Enter" || e.key === " ") {
                onCopy();
            }
        }, children: _jsx(ToolTip, { tip: props.tip, side: props.side, align: props.align, children: _jsx("div", { children: _jsx(Container, { color: showCheckIcon ? "success" : undefined, flex: "row", center: "both", children: showCheckIcon ? (_jsx(CheckIcon, { className: "tw-check-icon" })) : (_jsx(CopyIconSVG, { className: "tw-copy-icon" })) }) }) }) }));
};
//# sourceMappingURL=CopyIcon.js.map